var r = /* @__PURE__ */ ((_) => (_.STRIPE = "stripe", _.CREDIT_CARD = "credit_card", _.BANK_TRANSFER = "bank_transfer", _.CASH = "cash", _.AMENITIZ_PAY = "amenitiz_pay", _))(r || {}), E = /* @__PURE__ */ ((_) => (_.AT_BOOKING = "at_booking", _.BEFORE_CHECK_IN = "before_check_in", _.ON_CHECK_IN = "on_check_in", _.BEFORE_CHECK_OUT = "before_check_out", _))(E || {});
export {
  E as PaymentStages,
  r as PaymentType
};
